import gql from "graphql-tag";

export const EFFICIAL_CHECK = gql`
  mutation EfficialCheck($where: ProjectWhereInput) {
    efficialCheck(where: $where) {
      id
      fields
    }
  }
`;

export const EFFICIAL_DISMISS_ALERT = gql`
  mutation EfficialDismissAlert($where: EfficialAlertWhereInput) {
    efficialDismissAlert(where: $where) {
      id
      fields
    }
  }
`;

export const EFFICIAL_CONFIRM_ALERT = gql`
  mutation EfficialConfirmAlert($where: EfficialAlertWhereInput) {
    efficialConfirmAlert(where: $where) {
      id
      fields
    }
  }
`;

export const EFFICIAL_RESET_ALERT = gql`
  mutation EfficialResetAlert($where: EfficialAlertWhereInput) {
    efficialResetAlert(where: $where) {
      id
      fields
    }
  }
`;

export default {
  EFFICIAL_CHECK,
  EFFICIAL_DISMISS_ALERT,
  EFFICIAL_CONFIRM_ALERT,
  EFFICIAL_RESET_ALERT,
};
